<div class="container">
  <div class="title" fxLayout="row" fxLayoutAlign="space-between center">
    {{ openType === 'EDIT' ? 'Modifier le profil' : 'Créer un profil' }}
    <!-- <app-button
      *ngIf="openType !== 'EDIT' && isMultiHospitals"
      text="Importer"
      btnType="text"
      (click)="importProfile()"
    ></app-button> -->
  </div>

  <form *ngIf="formGroup; else Loading" class="body" fxLayout="column" fxLayoutAlign="start stretch">
    <app-image-picker
      style="overflow: unset"
      (onFileChange)="onFileChange($event)"
      [imageSource]="imageSource"
      (onDeleteFile)="deleteProfilePicture()"
      *ngIf="!isImportedProfile"
    ></app-image-picker>
    <img class="image" *ngIf="isImportedProfile" [src]="importedProfile?.profilePic" />

    <app-text-input
      (quit)="onNameQuit()"
      label="Nom"
      [formCtrl]="formGroup.get('lastName')! | formControl"
    ></app-text-input>

    <app-text-input
      (quit)="onNameQuit()"
      label="Prénom"
      [formCtrl]="formGroup.get('firstName')! | formControl"
    ></app-text-input>

    <app-text-input
      label="Numéro de téléphone"
      [formCtrl]="formGroup.get('phoneNumber')! | formControl"
    ></app-text-input>

    <div *ngIf="showMatchingResults && softwareName" class="default-mat-select" (click)="focusSearchElement($event)">
      <div class="mat-select-label">Correspondance avec {{ softwareName }}</div>
      <mat-select class="bg-white" #matRef [formControl]="selectFormControl" multiple>
        <mat-select-trigger>
          {{ selectedOptions.length ? selectedOptions[0].name : '' }}
          <span class="additional-selection" *ngIf="selectedOptions.length > 1">
            (+{{ selectedOptions.length - 1 }} {{ selectedOptions.length > 2 ? 'autres' : 'autre' }})
          </span>
        </mat-select-trigger>
        <div class="select-container">
          <mat-optgroup>
            <div class="height-100" fxLayout="row" fxLayoutAlign="space-between center">
              <input
                #search
                autocomplete="off"
                placeholder=""
                (keydown)="$event.stopPropagation()"
                (keyup)="onSearch(search.value)"
              />
              <button *ngIf="search.value" matSuffix mat-icon-button (click)="clearSearch($event)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </mat-optgroup>
          <mat-optgroup *ngIf="options && !options.length">
            <span>Aucun résultat</span>
          </mat-optgroup>
          <mat-option *ngFor="let option of options" [value]="option" (click)="optionClick(option)">
            <span class="font-size-14px">
              {{ option.name }}
              <span *ngIf="option.softwareLabel"> ({{ option.softwareLabel }})</span>
            </span>
          </mat-option>
        </div>
      </mat-select>
    </div>

    <div class="default-select">
      <div class="select-label">Poste</div>
      <div class="select-container">
        <select [formControl]="formGroup.get('type')! | formControl" required>
          <option *ngFor="let sp of postes" [value]="sp">
            {{ sp | toIADE }}
          </option>
        </select>
      </div>
    </div>

    <div class="default-select" *ngIf="isMultiHospitals && openType !== 'EDIT'">
      <div class="select-label">{{ !isImportedProfile ? 'Service' : 'Importer dans' }}</div>
      <div class="select-container">
        <select
          [formControl]="formGroup.get('hospitals')! | formControl"
          (change)="onSelectedHospitalChange()"
          required
          style="
            padding: 0 32px 0 8px !important;
            -webkit-padding-end: 32px !important;
            -webkit-padding-start: 8px !important;
          "
        >
          <option *ngFor="let hospital of hospitals" [ngValue]="hospital">
            <!-- {{ hospital.name }} -->
            {{ hospital.displayName }}
          </option>
        </select>
      </div>
    </div>

    <div class="default-select" *ngIf="showSeniority">
      <div class="select-label">Séniorité</div>
      <div class="select-container">
        <select [formControl]="formGroup.get('seniority')! | formControl" required>
          <option *ngFor="let seniority of seniorities" [value]="seniority.value">
            {{ seniority.value | formatSeniority }}
          </option>
        </select>
      </div>
    </div>

    <app-radio-button-group
      label="Statut"
      [formCtrl]="formGroup.get('residency')! | formControl"
      [elements]="residencies"
      layout="row"
    ></app-radio-button-group>

    <app-date-input
      style="overflow: unset"
      [formCtrl]="formGroup.get('startingDate')! | formControl"
      label="Date d'arrivée dans l'établissement"
      placeholder="JJ/MM/AAAA"
    ></app-date-input>

    @if (doesHospitalHaveCalendarsDataPipelineOption) {
      <div class="default-select calendars-toggle" fxLayout="row" fxLayoutAlign="start center">
        <mat-slide-toggle [formControl]="formGroup.get('excludeInCalendarsConnector')! | formControl">
          Ne pas récupérer les calendriers pour ce profil<br />
          ({{ calendarsSoftwareName }})
        </mat-slide-toggle>
      </div>
    }
  </form>

  <ng-template #Loading>
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-template>

  <div *ngIf="isNurse" class="buttons-row" fxLayout="row" fxLayoutAlign="end center">
    <app-button text="Annuler" btnType="text" (click)="closeDialog()"></app-button>
    <button
      *ngIf="openType === 'EDIT' && activeSkills"
      type="button"
      (click)="goToEditSkills()"
      [disabled]="!formGroup || !formGroup.valid"
      class="action-button editSkills"
    >
      <mat-label>Editer les compétences</mat-label>
    </button>
    <app-button
      [text]="
        openType === 'EDIT'
          ? 'Modifier le profil'
          : doesSelectedFormationHaveSkills
            ? 'Initialiser les compétences'
            : 'Créer le profil'
      "
      (click)="submitProfile()"
      [disabled]="!formGroup || !formGroup.valid"
    ></app-button>
  </div>

  <div *ngIf="!isNurse" class="buttons-row" fxLayout="row" fxLayoutAlign="end center">
    <app-button text="Annuler" btnType="text" (click)="closeDialog()"></app-button>
    <app-button
      [text]="
        openType === 'EDIT'
          ? 'Modifier le profil'
          : doesSelectedFormationHaveSkills
            ? 'Initialiser les compétences'
            : 'Créer le profil'
      "
      (click)="submitProfile()"
      [disabled]="!formGroup || !formGroup.valid"
    ></app-button>
  </div>
</div>
